export default __webpack_public_path__ + "static/media/AR.181f12b3.svg";